import React from 'react';
import '../../styles/footer.scss';
import BaseText from '../ui/typography/BaseText';
import InternalLinkButton from '../ui/buttons/InternalLinkButton';
import { PAGES_ENDPOINTS } from '../../constants/pages-endpoints';
import TrustPilotSVG from '../../images/inline/trustpilot.inline.svg';
import MoneyBack from '../../images/money-back.png';
import TrustPilot45SVG from '../../images/inline/trustpilot45.inline.svg';
import StripeLogo from '../../images/stripe.png';
import { Link } from 'gatsby';
import ContactModal from '../common/ContactModal';
import WhatsappModal from '../common/WhatsappModal';
import WeChatModal from '../common/WeChatModal';
import { COLORS, FONT_SIZE } from '../../constants/enum';
import AirCorporateLogoBlue from '../../images/air-corporate-logo-blue.webp';
export default function Footer() {
  return (
    <footer className="footer-container bg-gray-700">
      <div className="border-b border-blue-500 pb-16">
        <div className="global-max-width-wrapper mx-auto flex md:flex-row flex-col">
          <div className="w-11/12 mobile-footer">
            <h2 className="text-white text-5xl">Ready to start?</h2>
            <BaseText
              fontSize="23px"
              className="mt-5"
              fontWeight="text-medium"
              textColor="text-white md:whitespace-pre-line"
              title={`Your Hong Kong company and business\n account. Online and Simple.`}
            />
          </div>
          <div className="w-full flex flex-col gap-4 justify-center items-center">
            <InternalLinkButton
              fontSize="18px"
              padding="12px 32px"
              fontWeight="text-bold"
              caption="Get Started"
              path={PAGES_ENDPOINTS.GET_STARTED}
            />
            <div className="flex md:flex-row w-full items-center justify-center gap-8 footer-reviews">
              <img src={MoneyBack} className="w-36" alt="MoneyBack" />
              <img className="h-12" src={StripeLogo} alt="StripeLogo" />
              <div
                href="https://www.trustpilot.com/review/air-corporate.com"
                target="_blank"
                className="w-full flex flex-col items-center"
              >
                <TrustPilotSVG />
                <BaseText title="Rated Excellent" className="mb-2 mt-1" textColor="text-white" fontWeight="text-bold" />
                <TrustPilot45SVG height="28" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-16 mx-auto flex md:flex-row items-center justify-start gap-24 py-5 footer-navigation">
        <img src={AirCorporateLogoBlue} alt="AirCorporateLogoBlue" />
        <div className="flex md:flex-row gap-4 footer-navigation">
          <Link to="/" className="text-white text-medium">
            Home
          </Link>
          <Link to={PAGES_ENDPOINTS.AIR_CORPORATE} className="text-white text-medium">
            Secretary
          </Link>
          <Link to={PAGES_ENDPOINTS.ACCOUNTING_SERVICES} className="text-white text-medium">
            Accounting
          </Link>
          <Link to={PAGES_ENDPOINTS.BLOG} className="text-white text-medium">
            Blog
          </Link>
          <Link to={PAGES_ENDPOINTS.ABOUT_US} className="text-white text-medium">
            About Us
          </Link>
          <Link to={PAGES_ENDPOINTS.TERMS_CONDITIONS} className="text-white text-medium">
            Terms & Conditions
          </Link>
          <Link to={PAGES_ENDPOINTS.PRIVACY_POLICY} className="text-white text-medium">
            Privacy Policy
          </Link>
          <ContactModal>
            <Link to="?=contact" className="text-white text-medium">
              Contact
            </Link>
          </ContactModal>
          <div className="ml-4 flex gap-6">
            <WhatsappModal fill={COLORS?.WHITE} />
          </div>
          <div className="ml-4 flex gap-6">
            <WeChatModal fill={COLORS?.WHITE} />
          </div>
        </div>
      </div>
    </footer>
  );
}
